import { logger } from './logging'

export const copyToClipboard = (ref: React.RefObject<HTMLInputElement>, clipboard: any) =>
  ref.current ? clipboard.copy(ref.current.value) : logger.error('copyToClipboard error - No ref found')
